import styled from 'styled-components';

import { flexSpaceBetween, flexStart } from '../../style/reusableStyle';

export const PrinterContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background-color: ${({ theme }) => theme.colors.lighterBackground};
  }
  & .table-container {
    margin-bottom: 20px;
  }
`;

export const TitleFilterContainer = styled.div`
  ${flexSpaceBetween(0)};
  margin-bottom: 20px;
  width: 100%;

  & .head-add-btn {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;

    & .title-wrapper {
      width: 100%;
      ${flexSpaceBetween(0)};
      & .head-add-btn {
        display: inline-flex;
      }
    }
  }
`;

export const FilterWrapper = styled.div`
  ${flexStart};
  gap: 16px;

  & .inside-filter-add-btn {
    display: inline-flex;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 1;
    width: 100%;
    & .search-input {
      flex: 1;
    }

    & .inside-filter-add-btn {
      display: none;
    }
  }
`;
